<template>
	<AppDialog
		width="620"
		min-height="260"
		max-height="690"
		:closeTop="'-30'"
		:closeRight="'-10'"
		:disableClose="disableClose"
		dialogName="ShareFeatureDialog"
	>
		<Col :class="{ 'short-mode': isShortMode }" class="dialog-content rounded">
			<ShareFeatureDialogHeader :service="service" :workflow="workflow" />
			<Col class="inner-content-container overflow-y-auto height-100">
				<ShareDialogContentDataProvider
					@close="close"
					:service="service"
					:workflow="workflow"
					:isShortMode="isShortMode"
					:isPostPublishMode="isPostPublishMode"
					@show-full-menu="() => (hideShortMode = true)"
				/>
			</Col>
			<CloseBuilderDrawerFooter v-if="showCloseBuilderButton" @close-builder="closeBuilder" />
		</Col>
	</AppDialog>
</template>
<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import CloseBuilderDrawerFooter from '@/components/dialogs/ShareFeatureDialog/CloseBuilderDrawerFooter.vue';
import ShareDialogContentDataProvider from '@/components/dialogs/ShareFeatureDialog/ShareDialogContentDataProvider.vue';
import ShareFeatureDialogHeader from '@/components/dialogs/ShareFeatureDialog/ShareFeatureDialogHeader.vue';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import WorkflowService from '@/utils/WorkflowService';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
export default {
	name: 'ShareFeatureDialog',
	components: {
		AppDialog,
		ShareFeatureDialogHeader,
		CloseBuilderDrawerFooter,
		ShareDialogContentDataProvider,
	},
	props: {
		workflowId: { type: Number },
		disableClose: { type: Boolean },
		isPostPublishMode: { type: Boolean },
		dialogPromiseHandlers: { type: Object },
		showCloseBuilderButton: { type: Boolean },
		closeBuilder: { type: Function },
	},
	computed: {
		...mapGettersShorthand({ useWorkflow: getWorkflow, getServiceBySlug }),
		workflow() {
			return this.useWorkflow(this.workflowId) || {};
		},
		service() {
			return this.contextServiceSlug ? this.getServiceBySlug(this.contextServiceSlug) : null;
		},
		contextServiceSlug() {
			return this.workflow.context_service_slug;
		},
		isPortal() {
			return WorkflowService.isOfTypeTool(this.workflow) && WorkflowService.isPublicAccess(this.workflow);
		},
		isShortMode() {
			return (this.isPostPublishMode || this.isPortal) && !this.hideShortMode;
		},
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	created() {
		ExtensionCommunicationService.notifyExtensionPageCreated();
	},
	data() {
		return {
			hideShortMode: false,
		};
	},
};
</script>
<style scoped lang="scss">
$header-height: 64px;
$dialog-min-height: 260px;
$dialog-max-height: 690px;
.dialog-content {
	overflow: hidden;
	height: 100% !important;
	background: var(--white);
	min-height: $dialog-max-height;
	max-height: $dialog-max-height;
	transition: var(--transition-time);

	// This mode is only for post publish sharing.
	&.short-mode {
		height: 100% !important;
		min-height: $dialog-min-height;
		.inner-content-container {
			transition: var(--transition-time);
			height: calc(100% - #{$header-height});
			min-height: calc(#{$dialog-min-height} - #{$header-height});
			max-height: calc(#{$dialog-max-height} - #{$header-height});
		}
		::v-deep {
			.user-select-combobox {
				// These are here for the transition animation
				height: 100%;
				min-height: 0px;
				transition: 0.5s;
				.v-select--is-menu-active {
					// If the menu is active, we need to set the min-height, to make the dialog height stretch.
					height: 100%;
					transition: 0.5s;
					min-height: 360px;
				}
			}
		}
	}
	// END
}
.rounded {
	border-radius: 10px;
}
.inner-content-container {
	transition: var(--transition-time);
	height: calc(#{$dialog-max-height} - #{$header-height});
}
</style>
